<template>
  <div class="registerbox">
    <div class="whitebg whitebg2" v-if="step == 1">
      <div class="ti">忘记密码</div>
      <div class="register">
        <dl>
          <a :class="{ active: forgetType == 'mobile'}"
            @click="forgetType = 'mobile'">手机号找回密码<i></i></a>
          <a :class="{ active: forgetType == 'email' }"
            @click="forgetType = 'email'">邮箱找回密码<i></i></a>
        </dl>
        <ul>
          <li :class="{ show: forgetType == 'mobile'}">
            <p>
              <span class="area">+86<i class="icondown-sign iconfont"></i></span>
              <input class="phone2" type="text" placeholder="请输入注册时使用的手机号"
                v-model="mobileForm.phone">
            </p>
            <p class="captcha-wrapper">
                <input class="captcha-input" type="text" placeholder="请输入验证码" v-model="captchaCode">
                <a  class="captcha-img" title='点击刷新验证码' @click="getCaptcha">
                  <img alt="验证码" :src="captchaBase64"/>
                </a>
              </p>
            <p>
              <input class="code" type="text" placeholder="请输入验证码" v-model="mobileForm.code">
              <v-code-button text="点击获取验证码" retry="重新发送" :second="30" mode="sms" type="forget"
                :target="mobileForm.phone" @error="toastTip" :captchaCode="this.captchaCode" :captchaKey="this.captchaKey" :getCaptcha="this.getCaptcha"/>
            </p>
           
            <div class="subbox"><button type="button" @click="submitForm">重置密码</button></div>
            <div class="l"><span class="fr">已有账号？<a @click="go('Home')">立即登录</a></span></div>
          </li>
          <li :class="{ show: forgetType == 'email'}">
            <p><input type="text" placeholder="请输入注册时使用的邮箱" v-model="emailForm.email"></p>
            <p class="captcha-wrapper">
                <input class="captcha-input" type="text" placeholder="请输入验证码" v-model="captchaCode">
                <a  class="captcha-img" title='点击刷新验证码' @click="getCaptcha">
                  <img alt="验证码" :src="captchaBase64"/>
                </a>
              </p>
            <p>
              <input class="code" type="text" placeholder="请输入验证码" v-model="emailForm.code">
              <v-code-button text="点击获取验证码" retry="重新发送" :second="30" mode="email" type="forget"
                :target="emailForm.email" @error="toastTip" :captchaCode="this.captchaCode" :captchaKey="this.captchaKey" :getCaptcha="this.getCaptcha"/>
            </p>
            <div class="subbox"><button type="button" @click="submitForm">重置密码</button></div>
            <div class="l"><span class="fr">已有账号？<a @click="go('Home')">立即登录</a></span></div>
          </li>
        </ul>
      </div>
    </div>
    <div class="whitebg whitebg3" v-if="step == 2">
      <div class="ti ti2">密码重置</div>
      <div class="register">
        <ul>
          <li class="show">
            <p>
              <input type="password" placeholder="请输入新的密码" v-model="password">
              <!-- <span class="error">请输入验证码</span> -->
            </p>
            <p>
              <input type="password" placeholder="请再次输入密码" v-model="password2">
              <!-- <span class="error">两次密码不一致</span> -->
            </p>
            <div class="subbox"><button type="button" @click="forgetForm">重置密码</button></div>
            <div class="l"><span class="fr">已有账号？<a @click="go('Home')">立即登录</a></span></div>
          </li>
        </ul>
      </div>
    </div>
    <v-toast :show.sync="showToast" :time="1000" :text="toastMsg"></v-toast>
  </div>
</template>

<script>
import httpClient from '@/api/base'
import Regex from '@/common/regex'
const queryString = require('query-string');

export default {
  name: 'ForgetPassword',
  data() {
    return {
      forgetType: 'mobile',
      mobileForm: {
        phone: "",
        code: "",
      },
      emailForm: {
        email: "",
        code: "",
      },
      loading: false,
      isLogin: false,
      showToast: false,
      toastMsg: '',
      step: 1,
      password: "",
      password2: "",
      captchaBase64:"",
      captchaCode: "",
      captchaKey: ""
    };
  },
  created() {
    this.fetchData();
    this.getCaptcha()
  },
  watch: {
    // 如果路由有变化，会再次执行该方法
    $route: "fetchData"
  },
  methods: {
    getCaptcha() {
      httpClient
        .get('/user/captcha')
        .then(({data}) => {
          this.captchaBase64 = data.imageBase64
          this.captchaKey = data.key
        })
        .catch((err) => {
           this.toastTip("出错了，请稍候重试")
        }) 
    },
    go(routeName, query = {}) {
      this.$router.push({
        name: routeName,
        query: {
          ...query
        }
      });
    },
    toastTip(msg) {
      this.showToast = true
      this.toastMsg = msg
    },
    submitForm() {
      debugger
      if (this.forgetType == 'mobile') {
        if (!Regex.mobile.test(this.mobileForm.phone)) {
          this.toastTip('手机号码不合法')
          return
        }
        if (!Regex.smsCode.test(this.mobileForm.code)) {
          this.toastTip('短信验证码不合法')
          return
        }
      } else {
        if (!Regex.email.test(this.emailForm.email)) {
          this.toastTip('邮箱不合法')
          return
        }
        if (!Regex.emailCode.test(this.emailForm.code)) {
          this.toastTip('邮箱验证码不合法')
          return
        }
      }

      // 这里去验证是否合法

      if (this.loading) {
        return
      }
      this.loading = true
      let form = {
        type: 2
      }
      if (this.forgetType == 'mobile') {
        form.username = this.mobileForm.phone
        form.captcha = this.mobileForm.code
      } else {
        form.username = this.emailForm.email
        form.captcha = this.emailForm.code
      }

      httpClient
        .get("/user/login/captcha/verify?" + queryString.stringify(form))
        .then(({ data }) => {
          this.loading = false;
          if (data.code == 0) {
            this.step = 2
          } else {
            // 错误提示
            this.toastTip(data.message)
          }
        })
        .catch((error) => {
          this.loading = false;
          // 错误提示
          // console.log(error)
          this.toastTip("出错了，请稍候重试")
        });
    },
    forgetForm() {
      if (!Regex.password.test(this.password1)) {
        this.toastTip('密码不合法(长度6-16位)')
        return
      }
      if (!Regex.password.test(this.password2)) {
        this.toastTip('密码不合法(长度6-16位)')
        return
      }
      if (this.password !== this.password2) {
        this.toastTip('两次密码输入不一致')
        return
      }
      // 发起重置
      if (this.loading) {
        return
      }
      this.loading = true

      let form = {
        password: this.password
      }
      if (this.forgetType == 'mobile') {
        form.phone = this.mobileForm.phone
        form.captcha = this.mobileForm.code
      } else {
        form.email = this.emailForm.email
        form.captcha = this.emailForm.code
      }
      httpClient
        .put("/user/password", form)
        .then(({ data }) => {
          this.loading = false;
          if (data.code == 0) {
            this.$router.replace({ name: 'ResetPasswordSuccess' })
          } else {
            // 错误提示
            this.toastTip(data.message)
          }
        })
        .catch((error) => {
          this.loading = false;
          // 错误提示
          // console.log(error)
          this.toastTip("出错了，请稍候重试")
        });
    },
    fetchData() {
    }
  }
}
</script>
<style scoped>
.captcha-wrapper {
  display: flex;
}
.captcha-wrapper .captcha-input {
  flex: 1;
}
.captcha-wrapper .captcha-img {
  width: 150px;
  margin-left: 8px;
}
</style>
